import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { LoggerService } from '../providers/logger.service';

@Component({
  selector: 'app-select-point',
  template: `<div id='abx-div'></div>`,
  styles: [
  ]
})
export class SelectPointComponent implements OnInit, OnChanges {
  @Input() active: boolean;
  @Output() selectPoint: EventEmitter<any> = new EventEmitter();

  private div: HTMLElement;

  data$: Observable<any>;

  constructor(private elementRef: ElementRef, private logger: LoggerService) { }

  ngOnInit() {
    this.div = this.elementRef.nativeElement.querySelector('div');

    //this.initMouseListener(this.active);

    //this.data$ = new Observable((observer) => {
    //  try {
    //    let scale = 1;
    //    const transform = window.getComputedStyle(this.elementRef.nativeElement.parentElement).transform;
    //    if (transform !== undefined && transform.startsWith('matrix(')) {
    //      scale = parseFloat(transform.split(',')[0].split('(')[1]);
    //    }
    //    this.div.style.width = this.elementRef.nativeElement.offsetWidth / scale + 'px';
    //    this.div.style.height = this.elementRef.nativeElement.offsetHeight / scale + 'px';

    //    this.initMouseListener(this.active);
    //  } catch (e) {
    //    this.logger.logInternalError('SELECT POINT: watch', e.message);
    //  }
    //});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('active' in changes) {
      this.initMouseListener(this.active);
    }
  }

  private initMouseListener(active: boolean) {
    if (active) {
      this.elementRef.nativeElement.addEventListener('mouseup', this.handleMouseUp.bind(this));
    } else {
      this.elementRef.nativeElement.removeEventListener('mouseup', this.handleMouseUp.bind(this));
    }
  }

  private handleMouseUp(ev: MouseEvent) {
    this.selectPoint.emit([ev.offsetX, ev.offsetY, ev.clientX, ev.clientY]);
  }
}
